<div
  #dietFormModal
  class="modal fade"
  id="importUserSelectorModal"
  tabindex="-1"
  aria-labelledby="importUserSelectorModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">
          Selecciona al usuario
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          (click)="closeModal()"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <input
          type="text"
          [(ngModel)]="searchText"
          (input)="search()"
          class="form-control mb-2"
          placeholder="Busca 🔍"
        />

        <span class="mt-2">Usuarios</span>
        <ul class="list-group">
          <li
            class="list-group-item user-name"
            *ngFor="let u of users"
            (click)="openImportRoutineSelectorModal(u)"
          >
            {{ u.firstName }} {{ u.lastName }}
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>

<app-import-objects-selector></app-import-objects-selector>
